/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyModule
 */
export interface WriteOnlyModule {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyModule
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyModule
     */
    label?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyModule
     */
    deleted: number;
    /**
     * 
     * @type {object}
     * @memberof WriteOnlyModule
     */
    features?: object;
}

export function WriteOnlyModuleFromJSON(json: any): WriteOnlyModule {
    return WriteOnlyModuleFromJSONTyped(json, false);
}

export function WriteOnlyModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'deleted': json['deleted'],
        'features': !exists(json, 'features') ? undefined : json['features'],
    };
}

export function WriteOnlyModuleToJSON(value?: WriteOnlyModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'label': value.label,
        'deleted': value.deleted,
        'features': value.features,
    };
}


